export default function ExperienceSection() {
  const experiences = [
    {
      icon: 'ri-cup-line',
      title: '茶道品鉴',
      desc: '在茶香氤氲中感受时光流转，让每一杯茶都成为一次心灵的洗涤与修行。',
    },
    {
      icon: 'ri-music-line',
      title: '古乐聆赏',
      desc: '琴瑟和鸣，箫笛悠扬。在古典音乐的韵律中触摸千年文脉的温度。',
    },
    {
      icon: 'ri-quill-pen-line',
      title: '书法雅集',
      desc: '笔墨纸砚间，与古人对话。以书法为桥，连接心灵与天地。',
    },
    {
      icon: 'ri-plant-line',
      title: '花艺修心',
      desc: '一花一世界，一叶一菩提。在插花中修得一份宁静致远的心境。',
    },
  ];

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-accent-600 font-heading text-sm tracking-[0.2em] mb-3">风月体验</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              在风月中，遇见更好的自己
            </h2>
            <p className="text-foreground-500 text-sm leading-relaxed mb-8">
              我们精心打造一系列风月美学体验活动，从茶道、香道到古乐聆赏、书法雅集，
              让每一位热爱生活的人都能在这里找到属于自己的诗意时刻。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {experiences.map((exp, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-200/50 transition-colors duration-300 group cursor-default"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 group-hover:bg-accent-500 group-hover:text-white transition-all duration-300 shrink-0">
                    <i className={`${exp.icon} text-lg`} />
                  </div>
                  <div>
                    <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-1">{exp.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed">{exp.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20in%20traditional%20silk%20hanfu%20dress%20performing%20tea%20ceremony%2C%20bamboo%20forest%20background%2C%20soft%20morning%20light%2C%20misty%20atmosphere%2C%20classical%20beauty%2C%20graceful%20movements%2C%20warm%20golden%20and%20green%20tones%2C%20fine%20art%20photography%2C%20ethereal%20dreamy%20quality&width=800&height=1000&seq=experience-main&orientation=portrait"
                alt="风月体验"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-48 h-32 rounded-lg overflow-hidden hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Traditional%20Chinese%20incense%20burner%20with%20curling%20smoke%2C%20calligraphy%20brush%20on%20rice%20paper%2C%20warm%20candlelight%2C%20dark%20wooden%20surface%2C%20zen%20meditation%20atmosphere%2C%20minimal%20composition%2C%20soft%20focus%2C%20warm%20amber%20tones&width=400&height=280&seq=experience-detail&orientation=landscape"
                alt="香道雅集"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}